<template>
  <div class="diacreport" v-if="!preview">
    <header class="dia-border grey">
      <div class="u-flex u-row-between">
        <div class="title-left u-flex">
          <div class="head-title-lable">
            报告名称<span style="color: #ed4014">*</span>
          </div>
          <Input
            maxlength="50"
            v-model="value"
            placeholder="请输入"
            style="width: 280px"
          ></Input>
        </div>
        <div class="u-flex">
          <!-- <Button style="margin-right:8px">保存</Button> -->
          <Button type="primary" @click="previewmthd">预览</Button>
        </div>
      </div>
      <div class="dia-line"></div>
      <div class="dia-specific">
        <div class="specific-left" v-if="realImagePath && content.type == 1">
          <img :src="realImagePath" alt="" v-if="oilSiteInfo" />
          <img src="@/assets/images/empty.png" v-else />
        </div>
        <div class="specific-right mw" v-if="oilSiteInfo">
          <div class="spcific-right-font u-flex">
            <!-- <div class="yu-suc"></div> -->
            <div>{{ content.synchronizeReport }}</div>
          </div>
          <div class="diasp-inputs">
            <div
              class="diasp-input u-flex"
              v-for="(index, key) in inputlist"
              :key="key"
            >
              <div class="diasp-input-left">
                <input
                  maxlength="10"
                  class="left-lable"
                  v-model="index.label"
                  placeholder="请输入"
                />
              </div>
              <div class="right-input">
                <input
                  maxlength="100"
                  v-model="index.value"
                  placeholder="请输入"
                />
              </div>
              <div style="width: 30px; height: 24px" class="u-flex u-row-end">
                <Tooltip
                  placement="bottom"
                  theme="light"
                  trigger="hover"
                  content="删除属性"
                >
                  <img
                    @click="del(index, key)"
                    class="pot"
                    style="position: relative; top: 2px"
                    src="@/assets/images/delect.png"
                    width="24px"
                    height="24px"
                  />
                </Tooltip>
              </div>
            </div>
            <div class="diasp-add pot" @click="inputAdd">
              <!-- style="width: calc(22% - 37px)" -->

              <img
                width="12px"
                height="12px"
                style="margin-right: 4px"
                src="@/assets/images/feradd.png"
              />

              <div>添加自定义属性</div>
            </div>
            <div @click="inputcler" class="reset pot">重置</div>
          </div>
        </div>
      </div>
    </header>
    <template v-for="(index, key) in sextends">
      <template v-if="index.type == 'char'">
        <DiaCurve
          :typeobj="{
            type: content.type,
            customerId: content.customerId,
            deviceId: content.deviceId,
            oilSiteId: content.oilSiteId,
            iotDeviceName: oilSiteInfo.iotDeviceName,
            iotProductKey: oilSiteInfo.iotProductKey,
          }"
          :item="index"
          @remove="compodel"
          @setData="setOverall"
          :index="key"
          :key="key"
          :diatice="diatice"
          v-if="diatice"
        />
      </template>
      <template v-if="index.type == 'text'">
        <QullText
          :item="index"
          @remove="compodel"
          @setData="setOverall"
          :key="key"
          :index="key"
        />
      </template>
      <template v-if="index.type == 'table'">
        <DiaTable
          :typeobj="{
            type: content.type,
            oilSiteId: content.oilSiteId,
            customerId: content.customerId,
            deviceId: content.deviceId,
          }"
          :item="index"
          @remove="compodel"
          @setData="setOverall"
          :key="key"
          :index="key"
        />
      </template>
    </template>

    <div class="dict-bottom">
      <div
        @click="add(key)"
        class="diasp-add pot button-diasp-add"
        v-for="(index, key) in buttontext"
        :key="key"
      >
        <img
          width="12px"
          height="12px"
          style="margin-right: 4px"
          src="@/assets/images/feradd.png"
        />
        <div>{{ index }}</div>
      </div>
    </div>
    <div class="rh-model" v-if="timbo" @click="modelmehods"></div>
  </div>
  <!-- <previewDiact :sextends="sextends" v-else /> -->
</template>
<script>
import ls from "store2";
import DiaCurve from "./components/DiaCurve";
import QullText from "./components/QullText";
import DiaTable from "./components/DiaTable";
import DiaportDraw from "./components/diaticreport-draw.vue";
import previewDiact from "./components/preview-diact.vue";
import {
  diagnosticdetail,
  diagnosticedit,
  reportname,
} from "@/api/warning/diagnostic";
import debounce from "@/util/debounce";
import moment from "moment";
import { mapState } from "vuex";
import { sockedDel, relatedInfo } from "@/api/business/rhlist";
import { validateActive } from "@/util/validate";

export default {
  name: "diaticreport",
  components: {
    DiaCurve,
    QullText,
    DiaTable,
    DiaportDraw,
    previewDiact,
  },
  data() {
    return {
      id: "",
      content: {},
      oilSiteInfo: null,
      value: "",
      inputlist: [
        {
          label: "",
          value: "",
        },
      ],
      diatice: null,
      buttontext: ["插入曲线", "插入文本", "插入报警"],
      sextends: [],
      body: {
        name: "",
        id: "",
        detail: {
          baseinfo: {
            extends: [],
          },
        },
      },
      preview: false,
      initialize: false,
      realImagePath: "",
      cvale: "",
      soikobj: undefined,
      timernum: 0,
      timbo: false,
    };
  },
  watch: {
    // dataFrom: {
    //   immediate: true,
    //   handler: function() {
    //   }
    // },
    value() {
      this.$nextTick(async () => {
        this.cvale = this.value;
        if (this.value == "") {
          this.cvale = "未命名报告";
        }
        this.$nextTick(async () => {
          if (validateActive(this.value)) {
            this.$Message.error("报告名称只允许输入中文英文数字与下划线");
            this.cvale = '未命名报告';
          } else {
            let data = await reportname(this.$route.query.id, this.cvale);

            this.editUp();
          }
        });
      });
    },
    inputlist: {
      deep: true,
      handler: function () {
        this.editUp();
      },
    },
  },
  computed: {
    ...mapState({
      sockedlist: (state) => state.pub.sockedlist,
    }),
    dataFrom() {
      this.editUp();
    },
  },
  mounted() {
    window.onbeforeunload = (event) => {
      // console.log('event', event);
      this.brmethods();
      window.onbeforeunload = null;
    };
    this.init();
  },
  beforeDestroy() {
    this.brmethods();
  },
  methods: {
    async brmethods() {
      let { data } = await sockedDel({
        id: this.id,
        type: this.soikobj.type,
      });
    },
    modelmehods() {
      this.$Modal.info({
        title: "提示",
        content: "页面编辑超时，请重新打开",
        onOk: () => {
          this.previewmthd();
        },
      });
    },
    inputcler() {
      this.inputlist = this.settext(this.content.type);
      this.editUp();
    },
    async editUp() {
      if (!this.initialize) return;
      let inputlist = this.$c.deepClone(this.inputlist);
      let sextends = this.sextends;
      let type0 = sextends[0];

      if (!(type0.type == "texts")) {
        sextends.unshift({
          type: "texts",
          list: inputlist,
          title: this.cvale,
        });
      } else {
        sextends[0] = {
          type: "texts",
          list: inputlist,
          title: this.cvale,
        };
      }
      this.body.detail.baseinfo.extends = [...sextends];

      this.body.name = this.cvale;
      this.body.directPush = false;
      debounce(async () => {
        let data = await diagnosticedit(this.body);
      }, 1000);
    },
    compodel(index) {
      this.sextends.splice(index, 1);
      this.$nextTick(() => {
        this.editUp();
      });
    },
    setOverall(obj) {
      const { index, type, title } = obj;

      if (type == "char") {
        this.sextends[index].option = obj.option;
        this.sextends[index].title = title;
        this.sextends[index].id = `char${index}`;
      } else if (type == "text") {
        this.sextends[index].text = obj.content;
        this.sextends[index].title = title;
      } else if (type == "tables") {
        this.sextends[index].table = obj.table;
        this.sextends[index].title = title;
        this.sextends[index].ocmvalue = obj.ocmvalue;
        this.sextends[index].runvalue = obj.runvalue;
      }
      this.editUp();
    },
    previewmthd() {
      //  ls.set("sextens",this.sextends)
      //  ls.set("diaitem",{...this.oilSiteInfo,...{conid:this.content.id}})
      let id = this.$route.query.id;
      this.$router.push({
        path: `/business/lookdiaticreport?id=${id}`,
      });
    },
    add(index) {
      if (index == 0) {
        let index = this.sextends.filter((e) => e.type == "char");

        if (index.length >= 10) {
          this.$Message.info("曲线数据最大为10个");
          return;
        } else {
          this.sextends.push({
            type: "char",
            option: {},
            id: "",
          });
        }
        236045;
      } else if (index == 1) {
        this.sextends.push({
          type: "text",
          text: "",
        });
      } else if (index == 2) {
        this.sextends.push({
          type: "table",
          table: [],
        });
      }
      this.editUp();
    },
    del(row, key) {
      this.inputlist.splice(key, 1);
      this.editUp();
    },
    inputAdd() {
      if (this.inputlist.length == 14) return;
      this.inputlist.push({
        label: "",
        value: "",
      });
    },
    settext(type) {
      let arr = [];
      if (type == 1) {
        arr = [
          {
            label: "consumerName",
            value: "所属客户",
          },
          {
            label: "deviceName",
            value: "所属设备",
          },
          {
            //   label: "formatGmtCreate",// 'gmtCreate'
            label: "gmtCreate",
            value: "创建时间",
          },
          {
            label: "oilSiteIotName",
            value: "润滑点编号",
          },
          {
            label: "application",
            value: "应用类型",
          },
          {
            label: "zhuangzhiName",
            value: "润滑点装置",
          },
          {
            label: "reVolume",
            value: "油箱容量",
          },
          {
            label: "oilingFatLiquoringPeriod",
            value: "传感器",
          },
          {
            label: "remake",
            value: "加油周期",
          },
        ];
      } else if (type == 2) {
        arr = [
          {
            label: "name",
            value: "设备类型",
          },
          {
            label: "globalCode",
            value: "设备编号",
          },
          {
            label: "customerName",
            value: "所属客户",
          },
          {
            label: "manufacturer",
            value: "设备制造商",
          },
          {
            label: "specifications",
            value: "设备规格",
          },
          {
            //   label: "formatGmtCreate",
            label: "gmtCreate",
            value: "创建时间",
          },
        ];
      } else {
        arr = [
          {
            label: "companyName",
            value: "公司名称",
          },
          {
            label: "consumerContact",
            value: "客户联系人",
          },
          {
            label: "consumerContactWay",
            value: "客户联系方式",
          },
          {
            label: "customerIndustryNames",
            value: "所属行业",
          },
          {
            label: "dutyParagraph",
            value: "客户税号",
          },
          {
            //   label: "formatGmtCreate",
            label: "gmtCreate",
            value: "创建时间",
          },
          {
            label: "consumerType",
            value: "客户类型",
          },
        ];
      }
      let list = [];

      Object.keys(this.oilSiteInfo).map((key) => {
        arr.forEach((e) => {
          if (e.label == key) {
            if (e.label == "consumerType") {
              list.push({
                label: e.value,
                value: this.oilSiteInfo[key] == 0 ? "直供" : "非直供",
              });
            } else if (e.label == "gmtCreate") {
              list.push({
                label: e.value,
                value: moment(this.oilSiteInfo[key]).format(
                  "yyyy-MM-DD HH:mm:ss"
                ),
              });
            } else if (e.label == "customerIndustryNames") {
              list.push({
                label: e.value,
                value: this.oilSiteInfo[key].toString(),
              });
            } else {
              list.push({
                label: e.value,
                value: this.oilSiteInfo[key],
              });
            }
          }
        });
      });

      return list;
    },
    setregulartimer() {
  
      clearTimeout(this.tttimer);
      this.tttimer = null;
      this.tttimer = setTimeout(() => {
        this.timbo = true;
        clearTimeout(this.tttimer);
      }, this.timernum);
      // this.timernum
    },
    async init() {
      let that = this;
      // document.addEventListener("keydown", function (event) {
      
      //   // 检查是否按下了Ctrl键并同时按下了S键
      //   if (event.ctrlKey && (event.key === "s" || event.key === "S")) {
      //     // 阻止默认的保存页面行为
      //     event.preventDefault();

      //     // 在这里执行你想要的其他操作
      //     that.emit();
      //   }
      // });
      // report
      this.timbo = false;
      let item = this.sockedlist.find((e) => e.type == "report");
      this.soikobj = item;
      this.timernum = item.totalTime * (1000 * 60);
      this.setregulartimer();

      this.initialize = false;
      let id = this.$route.query.id;
      this.id = id;
      let objname = null;
      let { data } = await diagnosticdetail(id);
      if (data.type == 1) {
        //润滑点
        objname = "oilSiteInfo";
      } else if (data.type == 2) {
        //设备报告
        objname = "deviceInfo";
      } else {
        //客户报告
        objname = "customerInfo";
      }

      this.content = data;
      let arr = [];
      let list = [];
      this.oilSiteInfo = data.baseInfo[objname];
      this.diatice = {
        char: {
          oilSiteIotName: data.baseInfo[objname].oilSiteIotName,
          oilSiteTypeId: data.oilSiteTypeId,
        },
        oilSiteModelVOList: data.baseInfo[objname].oilSiteModelVOList,
      };

      if (data.type == 1) {
        this.realImagePath = data.baseInfo.realImagePath;
      } else if (data.type == 2) {
        this.oilSiteInfo = {
          ...this.oilSiteInfo,
          ...data.baseInfo.deviceTypeInfo,
        };
      } else {
        this.oilSiteInfo.name = this.oilSiteInfo.companyName;
      }
      list = this.settext(data.type);

      this.sextends = data.baseInfo.extends || []; //sextends

      if (this.sextends.length == 0) {
        this.inputlist = list;
      } else {
        // 处理时间格式
        this.sextends[0].list.forEach((item, index) => {
          if (item.label == "创建时间") {
            item.value = this.formattedDatetime(item.value);
          }
        });
        this.inputlist = this.sextends[0].list;
      }

      let sextends = this.sextends;

      if (sextends.length > 0 && sextends[0].type !== "texts") {
        this.sextends.unshift({
          type: "texts",
          title: "",
          list: this.inputlist,
        });
      } else if (this.sextends.length > 0) {
        this.value = this.sextends[0].title;
      } else if (this.sextends.length == 0) {
        this.sextends.unshift({
          type: "texts",
          title: "",
          list: this.inputlist,
        });
      }

      this.body.detail.baseinfo = data.baseInfo;
      this.body.name = data.name;
      this.body.id = data.id;
      this.value = data.name;
      this.cvale = data.name;

      this.$nextTick(() => {
        this.initialize = true;
        this.$forceUpdate();
        this.editUp();
      });

      this.$store.state.spinShow = false;
    },
    formattedDatetime(value) {
      // 时间转换
      const dateObj = new Date(value);

      const year = dateObj.getFullYear();
      const month = dateObj.getMonth() + 1; // Month starts from 0, so add 1

      const day = dateObj.getDate();
      const hour = dateObj.getHours();
      const minute = dateObj.getMinutes();
      const second = dateObj.getSeconds();

      const formattedDatetime = `${year}-${month < 10 ? "0" + month : month}-${
        day < 10 ? "0" + day : day
      } ${hour < 10 ? "0" + hour : hour}:${
        minute < 10 ? "0" + minute : minute
      }:${second < 10 ? "0" + second : second}`;
      return formattedDatetime;
    },
  },
};
</script>

<style lang="less">
.dia-border {
  width: 100%;
  padding: 16px 16px 35px 16px;
}

.diacreport {
  .grey {
    background: #fbfbfb;
  }

  .head-title-lable {
    font-size: 12px;
    font-weight: 400;
    color: #555555;
    margin-right: 12px;
  }

  .dia-line {
    width: 100%;
    height: 1px;
    opacity: 0.1;
    background: #707070;
    margin: 18px 0;
  }

  header {
    .dia-specific {
      display: flex;
      align-items: center;
      .specific-left {
        //   flex: 0 0 340px;
        //   height: 246px;
        flex: 0 0 230px !important;
        height: 230px !important;
        margin-right: 17px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .specific-right {
        padding-top: 16px;

        .spcific-right-font {
          font-size: 24px;
          line-height: 1;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.851);

          .yu-suc {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            margin-right: 8px;
          }
        }

        .diasp-inputs {
          width: 100%;
          height: 202px;
          display: flex;
          flex-direction: column;
          flex-wrap: wrap;
          margin-top: 8px;

          position: relative;
          align-content: flex-start;

          .diasp-input {
            width: 22%;
            margin-bottom: 8px;

            margin-right: 79px;
            .diasp-input-left {
              width: 96px;
              height: 32px;
              border: 1px solid #dedede;
              margin-right: 8px;
              text-align: left;
              padding: 0 8px;

              .left-lable {
                margin-right: 16px;
              }

              input {
                width: 100%;
                height: 100%;
                border: none;
                text-align: left;
                background: rgba(0, 0, 0, 0);
              }
            }

            .right-input {
              flex: 1;
              height: 32px;
              border: 1px solid #dedede;
              padding: 0 16px;

              input {
                border: none;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0);
              }
            }
          }

          .reset {
            position: absolute;
            width: 68px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            border-radius: 0px 0px 0px 0px;
            opacity: 1;
            border: 1px solid #dedede;
            bottom: 10px;
            right: 0;
            font-size: 12px;
            font-weight: 400;
            color: #555555;
          }
        }
      }
    }
  }
}

.button-diasp-add {
  width: 93px !important;
  margin-right: 8px;
}

.diasp-add {
  width: calc(~"22% - 30px");
  height: 32px;
  border: 1px solid #dddddd;
  background: #fafafa;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: normal;
  color: #888888;
  &:hover {
    background: #ffffff;
  }
}

.dict-bottom {
  width: 100%;
  height: 144px;
  background: #fbfbfb;
  display: flex;
  align-items: center;
  justify-content: center;

  .dict-btn {
    padding: 6px 16px;
    height: 32px;
    border: 1px solid #dddddd;
  }
}

.de-com {
  font-size: 18px;
  color: rgba(55, 61, 65, 1);
}
</style>
<style>
.olisname {
  border: 1px solid red !important;
}
.uti {
  position: relative;
  left: 9px;
  width: 100%;
}
</style>